const RiskAndCoverageStyles = {
  summaryContainer: {
    display: "flex",
    gap: "40px",
    marginBottom: "24px",
    alignItems: "center",
  },
  summaryLabel: {
    fontSize: "16px",
    color: "#888",
    fontWeight: 400,
  },
  summaryValue: {
    fontSize: "25px",
    fontWeight: 400,
    color: "#222",
    paddingTop:"10px"
  },
  summaryBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minWidth: "120px",
  },
  locationAccordion: {
    marginBottom: "18px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    border: "1px solid #e0e0e0",
    background: "#fff",
  },
  expandIcon: {
    border: "1px solid #cccccc",
    borderRadius: "50px",
  },
  locationHeaderBox: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    alignItems: "center",
    width: "100%",
    paddingRight: "10px",
  },
  placedIcon: {
    fontSize: "40px",
    color: "orange",
    WebkitTextStroke: "2px orange",
    marginTop:"1rem"

    // "@media (max-width: 768px)": {
    //   fontSize: "24px",
    // },
  },
  locationTitle: {
    fontWeight: 500,
    fontSize: "18px",
    color: "#222",
    "@media (max-width:370px)": {
      fontSize:"12px",
    },
  },
  locationAddress: {
    color: "#666",
    fontSize: "15px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
    "@media (max-width:370px)": {
      fontSize:"12px",
    },
  },
  riskCountBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "120px",
    margin: "0 auto",
  },
  riskCountText: {
    fontWeight: 500,
    fontSize: "16px",
    //color: "#20a7db",
  },
  riskAccordion: {
    margin: "16px 0",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    background: "#fafbfc",
  },
  messageCard: {
    marginTop: "32px",
    padding: "32px",
    textAlign: "center",
    background: "#f8f8f8",
    borderRadius: "10px",
    boxShadow: "none",
  },
  locationLeftBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  locationLabel: {
    fontWeight: 400,
    fontSize: "16px",
    color: "#888",
    marginBottom: "2px",
  },
  riskCountLabel: {
    fontWeight: 400,
    fontSize: "16px",
    color: "#888",
    textAlign: "right",
    marginBottom: "2px",
  },
  // --- Added for moving inline styles from RiskAndCoverage.tsx ---
  pagePaddingBox: {
    padding: "20px 0px",
  },
  riskNameCellBox: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  detailsIconButtonVisible: {
    marginLeft: '8px', // ml: 1 -> 8px
    padding: '4px',    // p: 0.5 -> 4px
    justifySelf: 'flex-end',
    visibility: 'visible',
  },
  detailsIconButtonHidden: {
    marginLeft: '8px', // ml: 1 -> 8px
    padding: '4px',    // p: 0.5 -> 4px
    justifySelf: 'flex-end',
    visibility: 'hidden',
  },
  tableContainerBox: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    marginBottom: '16px', // mb: 2 -> 16px
  },
  // Right-aligned table cell styles
  rightAlignedCell: {
    textAlign: 'right',
    justifyContent: 'flex-end',
  },
  drawerPaper: {
    width: '800px',
    padding: 0,
    boxSizing: 'border-box',
    background: '#fff',
  },
  drawerBox: {
    padding: 0,
    width: '100%',
  },
  drawerHeaderBox: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '16px',
    paddingBottom: '8px',
    borderBottom: '1px solid #e0e0e0',
  },
  drawerHeaderLabel: {
    color: '#888',
    fontSize: '15px',
    marginRight: '8px',
  },
  drawerSelect: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#222',
    minWidth: '150px',
    '.MuiSelect-icon': { top: 'calc(50% - 12px)' },
  },
  drawerSelectLob: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#222',
    marginRight: '8px',
    minWidth: '100px',
    '.MuiSelect-icon': { top: 'calc(50% - 12px)' },
  },
  drawerSelectRisk: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#222',
    minWidth: '180px',
    '.MuiSelect-icon': { top: 'calc(50% - 12px)' },
  },
  flex1: {
    flex: 1,
  },
  drawerTabsBox: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '16px',
  },
  drawerTabs: {
    minHeight: '40px',
  },
  drawerTabIndicator: {
    height: '3px',
  },
  drawerTab: {
    textTransform: 'none',
    fontWeight: 500,
    minWidth: '120px',
    minHeight: '40px',
    fontSize:'16px'
  },
  drawerTabCoverage: {
    textTransform: 'none',
    fontWeight: 500,
    minWidth: '180px',
    minHeight: '40px',
    fontSize:'16px'
  },
  drawerTotalPremiumLabel: {
    fontWeight: 400,
    color: '#888',
    fontSize: '16px',
  },
  drawerTabContentBox: {
    padding: '24px',
    "@media (max-width: 460px)": {
      padding: '16px',
    },
  },
  riskSpecificFieldsBox: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px', // gap: 3 -> 24px
    "@media (max-width: 768px)": {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '16px',
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },
  },
  coverageHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '8px',
    paddingRight: '8px',
    marginTop: '8px',
   
  },
  coverageHeaderLabel: {
    color: '#888',
    fontSize: '16px',
  },
  coverageHeaderLabelLimit: {
    color: '#888',
    fontSize: '16px',
    textAlign: 'right',
    minWidth: '120px',
  },
  coverageHeaderDivider: {
    borderBottom: '2px solid #bdbdbd',
    marginTop: '4px',
    marginBottom: '16px',
  },
  coverageRowsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    "@media (max-width: 600px)": {
      gap: '0px',
    },
  },
  coverageRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '4px',
    paddingBottom: '4px',
    "@media (max-width: 600px)": {
      flexDirection: 'row',
      alignItems: 'flex-start',
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '12px',
      paddingBottom: '12px',
      gap: '8px',
    },
  },
  coverageNameBox: {
    maxWidth: '400px',
    "@media (max-width: 600px)": {
      maxWidth: '60%',
      width: '60%',
      minWidth: '0',
      flex: '1',
    },
  },
  coverageNameText: {
    fontWeight: 500,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    "@media (max-width: 600px)": {
      fontSize: '16px',
      //fontWeight: 600,
      //color: '#222',
      //wordBreak: 'break-all',
      overflowWrap: 'break-word',
      hyphens: 'auto',
    },
  },
  coverageTypeText: {
    fontSize: '13px',
    color: '#888',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    "@media (max-width: 600px)": {
      fontSize: '14px',
      marginTop: '4px',
      wordBreak: 'break-all',
      overflowWrap: 'break-word',
      hyphens: 'auto',
    },
  },
  coverageLimitText: {
    fontWeight: 500,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    "@media (max-width: 600px)": {
      //fontSize: '18px',
      //fontWeight: 600,
      //color: '#222',
      alignSelf: 'flex-start',
      minWidth: '40%',
      textAlign: 'right',
      wordBreak: 'break-all',
      overflowWrap: 'break-word',
      hyphens: 'auto',
    },
  },
  coverageRowDivider: {
    borderBottom: '1px solid #e0e0e0',
    opacity: 0.7,
    marginLeft: '8px',
    marginRight: '8px',
    "@media (max-width: 600px)": {
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      marginBottom: '0px',
    },
  },
  liabilityLabelValueContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  claimsCardItemHeading: {
    overflow: "hidden",
    //color: "#1D252B",
    fontSize: "16px",
    //fontFamily: "Noto Sans",
    //fontWeight: "100",
    textOverflow: "ellipsis",
    "@media (max-width:599px)": {
      fontSize: "16px",
    },
    "@media (min-width:600px) and (max-width:1024px)": {
      whiteSpace: "nowrap",
    },
  },
  claimsCartItemContent: {
    //color: "#1D252B",
    fontSize: "14px",
    color: "#888",
    //fontFamily: "Noto Sans",
    //fontWeight: "500",
    whiteSpace: "wrap",
    "@media(max-width:599px)": {
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontFamily: '"Noto Sans"',
    },
    "@media (min-width: 1025px) and (max-width: 1366px)": {
      // overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  drawerTabsContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    "@media (max-width: 768px)": {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '8px',
    },
  },
  // Mobile limit container styles
  mobileLimitContainer: {
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'flex-end',
    "@media (max-width: 700px)": {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    "@media (min-width: 701px)": {
      display: 'block',
    }
  },
  // Mobile limit text styles
  mobileLimitText: {
    "@media (max-width: 700px)": {
      fontSize: '16px',
      fontWeight: 500,
      marginBottom: '2px',
    },
    "@media (min-width: 701px)": {
      display: 'none',
    }
  },
  // Desktop limit text styles
  desktopLimitText: {
    "@media (max-width: 700px)": {
      display: 'none',
    },
    "@media (min-width: 701px)": {
      display: 'block',
    }
  },
  // Single limit mobile text styles
  singleLimitMobileText: {
    "@media (max-width: 700px)": {
      fontSize: '16px',
      fontWeight: 500,
    },
    "@media (min-width: 701px)": {
      display: 'none',
    }
  },
};

export default RiskAndCoverageStyles;